"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _childrenUserManage = require("@/api/userCenter/childrenUserManage");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "AddSubAccount",
  components: {
    dragDialog: _DragDialog.default
  },
  props: {
    accountTypeList: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      capsTooltip: false,
      passwordType: 'password',
      confirmPasswordType: 'password',
      ebSysAccount: {
        accountNo: '',
        accountName: '',
        activateEmail: '',
        accountType: '1',
        activeFlag: '1',
        lockFlag: '0',
        registUser: '3',
        bookingViewType: '1'
      },
      rules: {
        activateEmail: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: 'blur'
        }, {
          required: true,
          type: 'email',
          message: this.$t('ebSysAccount.invalidEmail'),
          trigger: ['blur', 'change']
        }],
        accountNo: [{
          required: true,
          trigger: 'blur',
          validator: this.validateAccountName
        }],
        accountName: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: 'blur'
        }],
        password: [{
          required: true,
          trigger: 'blur',
          validator: this.validatePassword
        }, {
          min: 6,
          max: 30,
          message: this.$t('home.passWordError'),
          trigger: 'blur'
        }],
        confirmPassword: [{
          required: true,
          message: this.$t('login.passwordRequire'),
          trigger: 'blur'
        }, {
          validator: this.comparePassword,
          trigger: 'blur'
        }]
      },
      loading: false
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    validateAccountName: function validateAccountName(rule, value, callback) {
      var usernamePattern = /^[A-Z][A-Z0-9]{4,19}$/;
      var usernamePatternNum = /[0-9]+/;
      if (!value || value.length === 0) {
        callback(new Error(this.$t('home.messAccountNo')));
      } else if (!usernamePattern.test(value) || !usernamePatternNum.test(value)) {
        callback(new Error(this.$t('home.messagePassAccount')));
      } else {
        callback();
      }
    },
    showPwd: function showPwd() {
      var _this = this;
      if (this.passwordType) {
        this.passwordType = '';
        this.$nextTick(function () {
          _this.$refs.password.focus();
        });
      } else {
        this.passwordType = 'password';
        this.$nextTick(function () {
          _this.$refs.password.focus();
        });
      }
    },
    showConfPwd: function showConfPwd() {
      var _this2 = this;
      if (this.confirmPasswordType) {
        this.confirmPasswordType = '';
        this.$nextTick(function () {
          _this2.$refs.confirmPassword.focus();
        });
      } else {
        this.confirmPasswordType = 'password';
        this.$nextTick(function () {
          _this2.$refs.confirmPassword.focus();
        });
      }
    },
    validatePassword: function validatePassword(rule, value, callback) {
      var passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#￥%&])[A-Za-z\d!@#￥%&]{8,30}$/;
      if (!value || value.length === 0) {
        callback(new Error(this.$t('login.passwordRequire')));
      }
      if (!passwordPattern.test(value)) {
        callback(new Error(this.$t('home.messagePass')));
      } else {
        callback();
      }
    },
    comparePassword: function comparePassword(rule, value, callback) {
      if (value === '') {
        callback(new Error(this.$t('home.messageOne')));
      } else if (value !== this.ebSysAccount.confirmPassword) {
        callback(new Error(this.$t('home.messageTwo')));
      } else {
        callback();
      }
    },
    opened: function opened() {
      this.handleClear();
    },
    handleClear: function handleClear() {
      var userInfo = this.userInfo;
      this.ebSysAccount = {
        accountNo: '',
        accountName: '',
        activateEmail: '',
        accountType: '1',
        activeFlag: '1',
        lockFlag: '0',
        registUser: '3',
        bookingViewType: '1',
        simisCompanyCode: userInfo.simisCompanyCode,
        simisCompanyNameCn: userInfo.simisCompanyNameCn,
        simisCompanyNameEn: userInfo.simisCompanyNameEn
      };
    },
    closed: function closed() {
      var _this3 = this;
      this.$nextTick(function () {
        _this3.$refs['ebSysAccount'].clearValidate();
        _this3.$refs['ebSysAccount'].resetFields();
      });
    },
    saveFormClick: function saveFormClick() {
      var _this4 = this;
      this.$refs.ebSysAccount.validate(function (valid) {
        if (valid) {
          var params = JSON.parse(JSON.stringify(_this4.ebSysAccount));
          params.password = window.btoa(params.password);
          _this4.loading = (0, _utils.load)();
          (0, _childrenUserManage.addSubAccount)(params).then(function (res) {
            if (res.success) {
              _this4.$parent.setInitDialogAddUserVisible(false);
              _this4.$parent.searchFormData();
              _this4.$message({
                message: _this4.$t('userCenter.billConsigneeApplication.addSuccess'),
                type: 'success'
              });
            } else {
              _this4.$message({
                message: res.errorMessages[0],
                type: 'error'
              });
            }
          }).catch(function (err) {
            _this4.$message({
              message: err.errorMessages[0],
              type: 'error'
            });
          }).finally(function () {
            _this4.loading.close();
          });
        }
      });
    }
  }
};